<template>
  <Loader :promise="promise" theme="default" class="task-reference-residential">
    <Product v-if="item" :value="item" theme="list" />
  </Loader>
</template>

<script>
import Api from '@/api/Product'
import Product from '@/components/Product/TaskCard'

export default {
  props: {
    value: String,
  },
  watch: {
    value: {
      handler: 'fetch',
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      item: null,
    }
  },
  methods: {
    fetch() {
      this.promise = Api.get({ id: this.value }, { query: 'TaskReferenceProduct' }).then(item => (this.item = item))
    },
  },
  components: {
    Product,
  },
}
</script>
